module.exports = __webpack_public_path__ + "img/logo.902a8988.svg";